import React from "react";
import styled from "styled-components";
import { Image, Row } from "react-bootstrap";
import { FormControl, TextField } from "@mui/material";
import { AppFlowActionButton, BackNavRow, PageContainer } from "../common/CommonStyles";
import { useTranslation } from "react-i18next";

const ContinueButton = styled(AppFlowActionButton)`
  font-size: 24px;
`;

interface Props {
  setFirstName: (firstName: string) => void;
  back: () => void;
}

export const EnterFirstName: React.FC<Props> = ({ setFirstName, back }) => {
  const { t } = useTranslation();

  const [tempFirstName, setTempFirstName] = React.useState(
    localStorage.getItem("firstName") || ""
  );

  return (
    <PageContainer>
      <BackNavRow callback={back} label={t("generic_nav_back")}>
        <h2>{t("enter_first_name_title")}</h2>
      </BackNavRow>

      <div className="text-center">
        <FormControl sx={{ m: 1, minWidth: 300 }}>
          <TextField
            id="firstName"
            label={t("enter_first_name_placeholder")}
            required={true}
            inputProps={{ maxLength: 20 }}
            value={tempFirstName}
            onChange={(e) => setTempFirstName(e.target.value)}
          />
        </FormControl>
      </div>
      <Row className="justify-content-center my-5">
        <Image
          className="mx-auto col-8"
          src={`${process.env.PUBLIC_URL}/teacher_waving_in_circle.png`}
          fluid
          style={{ maxWidth: "300px" }}
        />
      </Row>
      <ContinueButton
        disabled={!tempFirstName}
        isEnabled={!!tempFirstName}
        onClick={() => setFirstName(tempFirstName)}
      >
        {t("enter_first_name_start")}
      </ContinueButton>
    </PageContainer>
  );
};
